import { REQUIRED_EMAIL_VALIDATOR, REQUIRED_TEXT_FIELD_VALIDATOR } from '@/helpers/formHelpers/validators';
import { USER_ROLE_MAP, UserRoleType } from '@/const/user';
import { getExecutorWiresPath } from '@/bundle/_Executor/path/path';
import { getDepositorWiresPath } from '@/bundle/_Depositor/path/path';
import { getRecipientWiresPath } from '@/bundle/_Recipient/path/path';
import { getOpcoUsersPath } from '@/bundle/_Opco/_OpcoUsersPage/path/path';
import { object, ObjectSchema } from 'yup';
import { getDashboardPath } from '@/bundle/_OrgAdmin/pages/DashboardPage/path/path';

export const LOGIN_VALIDATION_SCHEMA: ObjectSchema<{ email: string }> = object().shape({
  email: REQUIRED_EMAIL_VALIDATOR,
});

export const PASSWORD_VALIDATION_SCHEMA: ObjectSchema<{ password: string }> = object().shape({
  password: REQUIRED_TEXT_FIELD_VALIDATOR,
});

export const DASHBOARD_REDIRECT_MAP = {
  [USER_ROLE_MAP.OPCO]: getOpcoUsersPath(),
  [USER_ROLE_MAP.ORG_ADMIN]: getDashboardPath(),
  [USER_ROLE_MAP.MASTER_ADMIN]: getDashboardPath(),
  [USER_ROLE_MAP.RECIPIENT]: getRecipientWiresPath(),
  [USER_ROLE_MAP.EXECUTOR]: getExecutorWiresPath(),
  [USER_ROLE_MAP.DEPOSITOR]: getDepositorWiresPath(),
};

export const getDashboardRedirectPath = (currentRole: UserRoleType) => {
  if (!currentRole) return '';

  return DASHBOARD_REDIRECT_MAP[currentRole];
};

export const LOGIN_ERROR_NOTIFICATION_OFFSET = { marginBottom: '24px' };
